import Image from 'next/image'
import React from 'react'
import styles from './styles.module.scss'

const Maintenance: React.FC = () => {
  return (
    <div className={styles.background}>
      <div className={styles.container}>
        <Image width={350} height={92} src="/img/logo.svg" alt="logo" />
        <h1>Sorry, we are down for maintenance</h1>
        <p>
          We are having scheduled maintenance. <br /> Casino will be available
          again in a few minutes
        </p>
      </div>
    </div>
  )
}

export default Maintenance
